import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Totes.frontend.types'

@Injectable({ providedIn: 'root' })
export class Totes_create_delete_or_update_container_statusesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { statusId?: number, status_name?: string, action?: string }): Promise<{ reasons?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/Totes/functions/create_delete_or_update_container_statuses`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

